export default __webpack_public_path__ + "static/media/3.b1b2b66e.jpeg";